<div class="flex flex-col items-center homeComponent">
  <div class="w-full max-w-5xl flex flex-col items-center text-center">
    <div class="flex items-center justify-center gap-3 sm:gap-4 logoImage">
      <img src="../../../assets/images/Cardio4Cities_Accelerator_logo.svg" alt="Cardio4Cities" class="object-contain" />
    </div>

    <p class="mt-6 max-w-3xl text-slate-700 text-sm sm:text-base leading-relaxed">
      The CARDIO4Cities Simulator is a powerful, data-driven, strategic tool that helps cities transform
      their population’s heart health at scale.
    </p>

    <div class="mt-8 flex flex-wrap items-center justify-center gap-4">
      @if (showT0) {
      <button type="button"
        class="group inline-flex items-center justify-center gap-2 rounded-2xl border border-sky-200 bg-white px-6 py-3 text-sm sm:text-base font-semibold text-sky-700 shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:border-sky-300 hover:bg-sky-50 hover:shadow-md"
        routerLink="/t0-dashboard">
        <span
          class="inline-flex h-8 w-8 items-center justify-center rounded-xl bg-sky-100 text-sky-700 transition-colors group-hover:bg-sky-200">
          <i class="pi pi-chart-bar text-sm"></i>
        </span>
        <span>T0 Dashboard</span>
      </button>
      }

      @if (showT6) {
      <button type="button"
        class="group inline-flex items-center justify-center gap-2 rounded-2xl border border-fuchsia-200 bg-white px-6 py-3 text-sm sm:text-base font-semibold text-fuchsia-700 shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:border-fuchsia-300 hover:bg-fuchsia-50 hover:shadow-md"
        routerLink="/enhanced-simulator">
        <span
          class="inline-flex h-8 w-8 items-center justify-center rounded-xl bg-fuchsia-100 text-fuchsia-700 transition-colors group-hover:bg-fuchsia-200">
          <i class="pi pi-sparkles text-sm"></i>
        </span>
        <span>Enhanced Simulator</span>
      </button>
      }
    </div>
  </div>

  <div class="w-full max-w-6xl grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 mt-10 sm:mt-12">
    <article class="rounded-xl border border-slate-200 bg-white p-5 sm:p-6 shadow-sm">
      <div class="flex items-start gap-3">
        <span
          class="inline-flex h-10 w-10 min-h-[2.5rem] min-w-[2.5rem] shrink-0 items-center justify-center rounded-md bg-rose-50 text-rose-600">
          <i class="pi pi-heart text-lg leading-none"></i>
        </span>
        <div class="min-w-0">
          <h5>Forecast your city’s CV disease burden</h5>
          <p class="mt-2 text-slate-600 text-sm leading-6">
            Project future disease and cost trends using local data sets to understand your population’s cardiovascular
            risk
          </p>
        </div>
      </div>
    </article>

    <article class="rounded-xl border border-slate-200 bg-white p-5 sm:p-6 shadow-sm">
      <div class="flex items-start gap-3">
        <span
          class="inline-flex h-10 w-10 min-h-[2.5rem] min-w-[2.5rem] shrink-0 items-center justify-center rounded-md bg-sky-50 text-sky-600">
          <i class="pi pi-sitemap text-lg leading-none"></i>
        </span>
        <div class="min-w-0">
          <h5>Tailor and test interventions</h5>
          <p class="mt-2 text-slate-600 text-sm leading-6">
            Compare intervention approaches, from screening to treatment, and simulate their health and cost across your
            city
          </p>
        </div>
      </div>
    </article>

    <article class="rounded-xl border border-slate-200 bg-white p-5 sm:p-6 shadow-sm">
      <div class="flex items-start gap-3">
        <span
          class="inline-flex h-10 w-10 min-h-[2.5rem] min-w-[2.5rem] shrink-0 items-center justify-center rounded-md bg-violet-50 text-violet-600">
          <i class="pi pi-chart-line text-lg leading-none"></i>
        </span>
        <div class="min-w-0">
          <h5>Support policy decisions with evidence</h5>
          <p class="mt-2 text-slate-600 text-sm leading-6">
            Translate forecasts into evidence-based roadmaps that inform actionable cardiovascular health strategies
          </p>
        </div>
      </div>
    </article>
  </div>
</div>

<!-- <app-location-world-map
  [title]="'Available city locations'"
  [subtitle]="'Click a city marker to open the T0 dashboard.'"
  [accessFeature]="'dashboard'"
  [accessTier]="'t0'"
  [targetRoute]="'/t0-dashboard'"
  [enableClickSelect]="true"
></app-location-world-map> -->